import { Suspense, type ReactElement, type ReactNode } from 'react';
import ProtectedRoute from './ProtectedRoute';
import PermissionRoute from './PermissionRoute';
import LoadingFallback from '../components/common/LoadingFallback';
import { en } from '../locale';
import type { Permission } from '../types/user';

export function withSuspense(element: ReactNode): ReactElement {
  return (
    <Suspense fallback={<LoadingFallback message={en.common.loadingPage} />}>{element}</Suspense>
  );
}

export function protectedRoute(element: ReactElement, permission?: Permission): ReactElement {
  const wrapped = permission ? (
    <PermissionRoute permission={permission}>{element}</PermissionRoute>
  ) : (
    element
  );
  return withSuspense(<ProtectedRoute>{wrapped}</ProtectedRoute>);
}

export function publicRoute(element: ReactElement): ReactElement {
  return withSuspense(element);
}
